// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
export {};
//# sourceMappingURL=manager.js.map